module.exports = require("babel-runtime/helpers/extends");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/extends"
// module id = 1
// module chunks = 0